import React from 'react';
import PropTypes from 'prop-types';
import { IconFilePDF } from '@xingternal/icons';

import styles from './fileThumbnail.css';

const FileThumbnail = ({ type, thumbnailUrl }) =>
  type.startsWith('image') ? (
    <img src={thumbnailUrl} alt="preview" className={styles.thumbnail} />
  ) : (
    <IconFilePDF width={30} height={30} className={styles.typeIcon} />
  );

FileThumbnail.propTypes = {
  type: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
};

FileThumbnail.defaultProps = {
  thumbnailUrl: '',
};

export default FileThumbnail;
